import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const ArrowRightIcon = createIcon({
  displayName: 'ArrowRightIcon',
  path: [
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M13.75 6.75L19.25 12L13.75 17.25'
    />,
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M19 12H4.75'
    />
  ],
  defaultProps: defaultProps
})
